import { createRoot } from 'react-dom/client';
import { store } from "./redux/store";

import { Provider } from 'react-redux';
import RequestInterceptor from './services/request.interceptor';
import { initiateApplicationSettings } from './redux/actions/application';
import { translations } from './i18n';
import 'react-tooltip/dist/react-tooltip.css';
import IdentityService from './services/identity.service';
import { DatasetPage } from './pages/dataset';

/** First path segment must be en, es, fr, or pt-BR (any casing); otherwise null. */
function getLocaleFromPathname(pathname: string): string | null {
  const segment = pathname.split('/').filter(Boolean)[0];
  if (!segment) return null;
  const lower = segment.toLowerCase();
  if (lower === 'en' || lower === 'es' || lower === 'fr') return lower;
  if (lower === 'pt-br') return 'pt-br';
  return null;
}

function resolvedLanguageToI18nAndUi(resolved: string): { i18nLang: string; uiLang: string } {
  const r = String(resolved).toLowerCase();
  if (r === 'pt-br' || r === 'pt') {
    return { i18nLang: 'pt', uiLang: 'pt-br' };
  }
  if (r === 'en' || r === 'es' || r === 'fr') {
    return { i18nLang: r, uiLang: r };
  }
  return { i18nLang: 'en', uiLang: 'en' };
}

declare global {
  interface Window {
    DataSeekViewer: any;
  }
}

window.DataSeekViewer = {
  initialise: (request: any) => {
    // Eliminates the 300ms delay between a physical tap
    // and the firing of a click event on mobile browsers
    // https://github.com/ftlabs/fastclick
    //FastClick.attach(document.body);

    const resolved =
      getLocaleFromPathname(window.location.pathname) ?? request.language ?? 'en';
    const { i18nLang, uiLang } = resolvedLanguageToI18nAndUi(resolved);
    const requestWithLanguage = { ...request, language: uiLang };

    store.dispatch(initiateApplicationSettings(requestWithLanguage));
    RequestInterceptor();

    translations.setLanguage(i18nLang);

    const container = document.getElementById(request.container) as HTMLElement;
    const root = createRoot(container);

    IdentityService.initialise().then((fingerprint) => {
      root.render(
        <Provider store={store}>
          <DatasetPage request={requestWithLanguage} />
        </Provider>
      );
    });
  }
}